"use client";
import React from "react";
import Image from "next/image";
import { useIsMobile } from "@/hooks/useIsMobile/useIsMobile";

interface IBrandImageProps {
  brandDesktopUrl: string;
  brandMobileUrl: string;
  alt?: string;
  caption?: string;
}

/**
 * BrandBannerImage component
 * Renders a responsive brand image for hotel banners, switching between desktop and mobile URLs based on device.
 */

const BrandBannerImage: React.FC<IBrandImageProps> = ({
  brandDesktopUrl,
  brandMobileUrl,
  alt,
  caption,
}) => {
  // Use mobile or desktop image based on device type
  const isMobile = useIsMobile();
  return (
    <Image
      src={isMobile ? brandMobileUrl || "" : brandDesktopUrl || ""}
      fill
      alt={alt ?? ""}
      aria-label={caption || ""}
      className="object-cover"
    />
  );
};

export { BrandBannerImage };
